export const AI_ANSWERS_QUOTA = 250;
export const QUESTION_MINIMUM_LENGTH = 25;
/* eslint-disable max-len */
export const AI_TOOLS_ERROR_MESSAGES = {
  ASK_AI:
    "Oops. Something went wrong. Your remaining number of answers has not been reduced. Feel free to try again. If that doesn't work, please refresh the page",
  DISCUSSION_QUESTIONS:
    "Oops. Something went wrong. This response wasn't counted. Feel free to try again.",
  ESSAY_PROMPTS:
    "Oops. Something went wrong. This response wasn't counted. Feel free to try again.",
  QUIZ_QUESTIONS:
    "Oops. Something went wrong. This response wasn't counted. Feel free to try again."
};
/* eslint-enable max-len */

export const AI_TOOL_CHANNELS = {
  ASK_AI: "AskAiChannel",
  DISCUSSION_QUESTIONS: "DiscussionQuestionsChannel",
  ESSAY_PROMPTS: "EssayPromptsChannel",
  QUIZ_QUESTIONS: "QuizQuestionsChannel"
};

export const AI_TOOL_NAMES = {
  ASK_AI: "ASK_AI",
  DISCUSSION_QUESTIONS: "DISCUSSION_QUESTIONS",
  ESSAY_PROMPTS: "ESSAY_PROMPTS",
  QUIZ_QUESTIONS: "QUIZ_QUESTIONS"
};

export const AI_TOOL_READABLE_NAMES = {
  ASK_AI: "Ask LitCharts AI",
  DISCUSSION_QUESTIONS: "Discussion Question Generator"
};

export const REUSABLES = {
  MESSAGE_TEXT: "messageText",
  SUBTOPIC: "subtopic",
  TITLE: "title",
  TOPIC: "topic"
};

export const AI_TOOLS_LABEL_MAP = {
  Characters: "character",
  "Line-by-Line Analysis": "lines",
  "Poetic Devices": "poetic device",
  Symbols: "symbol",
  Themes: "theme"
};

export const AMPLITUDE_BANNER_DATA_ATTRIBUTES = {
  [AI_TOOL_NAMES.DISCUSSION_QUESTIONS]: "discussionQuestionGeneratorBanner",
  [AI_TOOL_NAMES.QUIZ_QUESTIONS]: "quizQuestionGeneratorBanner",
  [AI_TOOL_NAMES.ESSAY_PROMPTS]: "essayPromptGeneratorBanner",
  [AI_TOOL_NAMES.ASK_AI]: "aiSignupBanner"
};

export const AMPLITUDE_QUESTION_ASKED_LARGE_ATTRIBUTES = {
  [AI_TOOL_NAMES.DISCUSSION_QUESTIONS]: "discussionQuestionAskedLarge",
  [AI_TOOL_NAMES.QUIZ_QUESTIONS]: "quizQuestionAskedLarge",
  [AI_TOOL_NAMES.ESSAY_PROMPTS]: "essayPromptAskedLarge",
  [AI_TOOL_NAMES.ASK_AI]: "aiQuestionAskedLarge"
};

export const AMPLITUDE_QUESTION_ASKED_SMALL_ATTRIBUTES = {
  [AI_TOOL_NAMES.DISCUSSION_QUESTIONS]: "discussionQuestionAskedSmall",
  [AI_TOOL_NAMES.QUIZ_QUESTIONS]: "quizQuestionAskedSmall",
  [AI_TOOL_NAMES.ESSAY_PROMPTS]: "essayPromptAskedSmall",
  [AI_TOOL_NAMES.ASK_AI]: "aiQuestionAskedSmall"
};

export const AMPLITUDE_QUESTION_ASKED_SMALL_COLLAPSED_ATTRIBUTES = {
  [AI_TOOL_NAMES.DISCUSSION_QUESTIONS]: "discussionQuestionAskedSmallCollapsed",
  [AI_TOOL_NAMES.QUIZ_QUESTIONS]: "quizQuestionAskedSmallCollapsed",
  [AI_TOOL_NAMES.ESSAY_PROMPTS]: "essayPromptAskedSmallCollapsed",
  [AI_TOOL_NAMES.ASK_AI]: "aiQuestionAskedSmallCollapsed"
};

export const AMPLITUDE_SIGNUP_INTRO_CHAT_ATTRIBUTES = {
  [AI_TOOL_NAMES.DISCUSSION_QUESTIONS]: "discussionQuestionSignupIntroChat",
  [AI_TOOL_NAMES.QUIZ_QUESTIONS]: "quizQuestionSignupIntroChat",
  [AI_TOOL_NAMES.ESSAY_PROMPTS]: "essayPromptSignupIntroChat",
  [AI_TOOL_NAMES.ASK_AI]: "aiSignupIntroChat"
};

export const AMPLITUDE_SIGNUP_FORM_LARGE_ATTRIBUTES = {
  [AI_TOOL_NAMES.DISCUSSION_QUESTIONS]: "discussionQuestionSignupFormLarge",
  [AI_TOOL_NAMES.QUIZ_QUESTIONS]: "quizQuestionSignupFormLarge",
  [AI_TOOL_NAMES.ESSAY_PROMPTS]: "essayPromptSignupFormLarge",
  [AI_TOOL_NAMES.ASK_AI]: "aiSignupFormLarge"
};

export const AMPLITUDE_SIGNUP_FORM_SMALL_COLLAPSED_ATTRIBUTES = {
  [AI_TOOL_NAMES.DISCUSSION_QUESTIONS]:
    "discussionQuestionSignupFormSmallCollapsed",
  [AI_TOOL_NAMES.QUIZ_QUESTIONS]: "quizQuestionSignupFormSmallCollapsed",
  [AI_TOOL_NAMES.ESSAY_PROMPTS]: "essayPromptSignupFormSmallCollapsed",
  [AI_TOOL_NAMES.ASK_AI]: "aiSignupFormSmallCollapsed"
};

export const AI_TOOLS_LOADING_DEFAULTS = { label: "Loading...", value: "1" };
